import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { livetvstatusResponseModel } from '../livetv/livetv-response-module';
import { LivetviddetailsDTO, LivetvlistdetailsDTO, livetvlistStatusDTO } from './dto/livetvlist.dto';
import { livetvliststatusResponseModel, livetvlisttvResponseModel } from './livetvlist-respone-module';
import { LivetvlistEntity } from './livetvlist.entity';

@Injectable()
export class LivetvlistService {
    constructor(
        @InjectRepository(LivetvlistEntity)
        private livetvlistRepository: Repository<LivetvlistEntity>
    ) {}


    async getlivetvdetails(queryParams,LivetviddetailsDTO:LivetviddetailsDTO, request):Promise<livetvlisttvResponseModel> {
        const response = new livetvlisttvResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const savedData = await this.livetvlistRepository.find({
                    relations:['livetv'],
                    where:{LivetvId:LivetviddetailsDTO.LivetvId,status: true},
                    order: { createdAt: 'DESC' }
                });
                if(savedData) {
                    response.status = true;
                    response.data = savedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else {
                const savedData = await this.livetvlistRepository.find({
                    relations:['livetv'],
                    where:{LivetvId:LivetviddetailsDTO.LivetvId,status: true},
                    order: { createdAt: 'DESC' }
                });
                if(savedData) {
                    response.status = true;
                    response.data = savedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getlivetvlist(queryParams, request:Request): Promise<livetvlisttvResponseModel> {
        const response = new livetvlisttvResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const activeTypes = await this.livetvlistRepository.find({
                    
                    relations:['livetv'],
                    where: {status: true},
                    order: { createdAt: 'DESC' }
                });
                if(activeTypes) {
                    response.status = true;
                    response.data = activeTypes;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else {
                const activeTypes = await this.livetvlistRepository.find({
                    
                    relations:['livetv'],
                    where: {status: true},
                    order: { createdAt: 'DESC' }
                });
                if(activeTypes) {
                    response.status = true;
                    response.data = activeTypes;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    
    async updatelivetvlist(queryParams, LivetvlistdetailsDTO: LivetvlistdetailsDTO, request:Request): Promise<livetvlisttvResponseModel> {
        const response = new livetvlisttvResponseModel();
        
        try {
            if(queryParams.apiVersion == 1) {
                const updatePostType = await this.livetvlistRepository.update(LivetvlistdetailsDTO.Id, LivetvlistdetailsDTO);
                ;
                const updatedData = await this.livetvlistRepository.find({
                    relations:['livetv'],
                    where:{Id:LivetvlistdetailsDTO.Id,status: true},
                    order: { createdAt: 'DESC' }
                });
                if(updatePostType) {
                    response.status = true;
                    response.data   = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'livetv details updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'livetv details Update Failed')
                }
            } else {
                const updatePostType = await this.livetvlistRepository.update(LivetvlistdetailsDTO.Id, LivetvlistdetailsDTO);
                ;
                const updatedData = await this.livetvlistRepository.find({
                    relations:['livetv'],
                    where:{Id:LivetvlistdetailsDTO.Id,status: true},
                    order: { createdAt: 'DESC' }
                });
                if(updatePostType) {
                    response.status = true;
                    response.data   = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'livetv details updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'livetv details Update Failed')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }


    async updatelivelisttvStatus(queryParams, livetvlistStatusDTO:livetvlistStatusDTO, request:Request): Promise<livetvliststatusResponseModel> {
        const response = new livetvliststatusResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const updateStatus = await this.livetvlistRepository.update(livetvlistStatusDTO.Id, livetvlistStatusDTO);
                const updatedData = await this.livetvlistRepository.findOne({
                    relations:['livetv'],
                    where:{Id:livetvlistStatusDTO.Id}
                });
                if(updateStatus) {
                    response.status = true;
                    response.data   = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'livetv list Status updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'comments Status Update Failed')
                }
            } else {
                const updateStatus = await this.livetvlistRepository.update(livetvlistStatusDTO.Id, livetvlistStatusDTO);
                const updatedData = await this.livetvlistRepository.findOne({
                    relations:['livetv'],
                    where:{Id:livetvlistStatusDTO.Id}
                });
                if(updateStatus) {
                    response.status = true;
                    response.data   = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'livetv list Status updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'comments Status Update Failed')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

}
